import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output, Renderer2,
  ViewEncapsulation
} from '@angular/core';
import {DragulaService} from "ng2-dragula";
import {NavigationService} from "../../../navigation.service";
import {NavigationInteractionsService} from "../../../navigation-interactions.service";
import {INavigationType} from "../../../navigation.interface";

@Component({
    selector: 'db-ecommerce-menu-structure',
    templateUrl: './ecommerce-menu-structure.component.html',
    styleUrls: ['./ecommerce-menu-structure.component.scss'],
    // viewProviders: [DragulaService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EcommerceMenuStructureComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() openSlider: EventEmitter<void> = new EventEmitter<void>();
  @Input() isDemo = false;
  @Input() opened = false;

  get menuItems() {
    return this.navigationInteractionsService.navigationItems.value;
  }

  set menuItems(items: INavigationType[]) {
    this.navigationInteractionsService.navigationItems.next(items);
  }


  constructor(
    private dragulaService: DragulaService,
    private _ngZone: NgZone,
    private renderer: Renderer2,
    private el: ElementRef,
    public navigationInteractionsService: NavigationInteractionsService,
    public navigationService: NavigationService) {
    try {
      this.dragulaService.createGroup('navigation', {
        accepts: (el: Element, target: Element, source: Element, sibling: Element): boolean => {
          const targetLevel = this.getNestingLevel(target);
          const level3 = targetLevel === 1 && el.classList.contains('3');
          const level2 = targetLevel === 2 && el.classList.contains('2');
          return !el.contains(target) && !level3 && targetLevel !== 3 && !level2;
        },
        direction: 'vertical',
      });
      this.dragulaService.find('navigation')
        .drake
        .on('drop', (el, source) => {
          this.navigationInteractionsService.hasChanges.next(true);
        });
    } catch (err) {
      console.log('errrr', err);
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const headerBannerContent = document.querySelector('.db-ai-builder-header-banner__content');

    if (headerBannerContent) {
      const menuStructureDragContainer = this.el.nativeElement.querySelector('.db-ecommerce-menu-structure-drag-container');

      const newHeight = 'calc(100vh - 500px)';
      this.renderer.setStyle(menuStructureDragContainer, 'height', newHeight);
    }
  }

  getNestingLevel(element: Element): number {
    let level = 0;
    let currentElement = element;

    while (currentElement && !currentElement.classList.contains('db-ecommerce-menu-structure-drag-container')) {
      if (currentElement.classList.contains('menu-draggable-item-sub')) {
        level++;
      }
      currentElement = currentElement.parentElement;
    }

    return level;
  }

  ngOnDestroy() {
    this.dragulaService.destroy('navigation');
  }

}
